"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ADMIN_ROLES: () => ADMIN_ROLES,
  BACKOFFICE_CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS: () => BACKOFFICE_CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS,
  BRUTE_INCOME_TYPES: () => BRUTE_INCOME_TYPES,
  CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS: () => CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS,
  CLIENT_DIGITAL_DOSSIER_SECTIONS_STATUS: () => CLIENT_DIGITAL_DOSSIER_SECTIONS_STATUS,
  COMPANY_ACTIVITIES: () => COMPANY_ACTIVITIES,
  COMPANY_STATUSES: () => COMPANY_STATUSES,
  COMPANY_TYPES: () => COMPANY_TYPES,
  CREDITOR_INSPECTION_RIGHTS: () => CREDITOR_INSPECTION_RIGHTS,
  CROP_PLEDGE_USER_ROLES: () => CROP_PLEDGE_USER_ROLES,
  CURRENCIES: () => CURRENCIES,
  DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS: () => DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS,
  DIGITAL_DOSSIER_SECTIONS: () => DIGITAL_DOSSIER_SECTIONS,
  DIGITAL_DOSSIER_STATUS: () => DIGITAL_DOSSIER_STATUS,
  DIGITAL_DOSSIER_SUBSECTIONS: () => DIGITAL_DOSSIER_SUBSECTIONS,
  DOCUMENT_TYPES: () => DOCUMENT_TYPES,
  ERROR_CODES: () => ERROR_CODES,
  EXCHANGES: () => EXCHANGES,
  EXPLOITATION_TYPES: () => EXPLOITATION_TYPES,
  FILE_MIME_TYPES: () => FILE_MIME_TYPES,
  HttpStatus: () => HttpStatus,
  IDENTITY_DOCUMENT_TYPES: () => IDENTITY_DOCUMENT_TYPES,
  IVA_CONDITION: () => IVA_CONDITION,
  LEASE_CONTRACT_TYPES: () => LEASE_CONTRACT_TYPES,
  MARITAL_STATUSES: () => MARITAL_STATUSES,
  NATIONALITIES: () => NATIONALITIES,
  OWNERSHIP_TYPES: () => OWNERSHIP_TYPES,
  PLEDGE_CROP_CLASSES: () => PLEDGE_CROP_CLASSES,
  PLEDGE_CROP_DEGREES: () => PLEDGE_CROP_DEGREES,
  PLEDGE_SECTIONS: () => PLEDGE_SECTIONS,
  PLEDGE_SECTION_STATUSES: () => PLEDGE_SECTION_STATUSES,
  PLEDGE_STATUSES: () => PLEDGE_STATUSES,
  POWER_OF_ATTORNEY_EXCHANGES: () => POWER_OF_ATTORNEY_EXCHANGES,
  PRODUCTS: () => PRODUCTS,
  PROFIT_TYPES: () => PROFIT_TYPES,
  PROVINCES: () => PROVINCES,
  QUERY_STATUSES: () => QUERY_STATUSES,
  REPRESENTATIVE_POSITIONS: () => REPRESENTATIVE_POSITIONS,
  RUCA_NOT_CURRENT_WARNING: () => RUCA_NOT_CURRENT_WARNING,
  RUCA_STATUSES: () => RUCA_STATUSES,
  SEARCH_DIGITAL_DOSSIER_ACTIONS: () => SEARCH_DIGITAL_DOSSIER_ACTIONS,
  SEARCH_DIGITAL_DOSSIER_STATUS: () => SEARCH_DIGITAL_DOSSIER_STATUS,
  SIGNATURE_LEVELS: () => SIGNATURE_LEVELS,
  SISA_ACTIVITIES: () => SISA_ACTIVITIES,
  SISA_SCORINGS: () => SISA_SCORINGS,
  USER_COMPANY_STATUSES: () => USER_COMPANY_STATUSES,
  USER_ROLES: () => USER_ROLES,
  USER_STATUSES: () => USER_STATUSES,
  USER_TYPES: () => USER_TYPES,
  VALIDATION_STATUSES: () => VALIDATION_STATUSES,
  VIEWER_DIGITAL_DOSSIER_GENERAL_STATUS: () => VIEWER_DIGITAL_DOSSIER_GENERAL_STATUS,
  YES_NO_OPTIONS: () => YES_NO_OPTIONS,
  adminRoles: () => adminRoles,
  backofficeClientDigitalDossierGeneralStatus: () => backofficeClientDigitalDossierGeneralStatus,
  bruteIncomeTypes: () => bruteIncomeTypes,
  clientDigitalDossierGeneralStatus: () => clientDigitalDossierGeneralStatus,
  clientDigitalDossierSectionsStatus: () => clientDigitalDossierSectionsStatus,
  companyActivities: () => companyActivities,
  companyStatuses: () => companyStatuses,
  companyTypes: () => companyTypes,
  creditorInspectionRights: () => creditorInspectionRights,
  cropPledgeUserRoles: () => cropPledgeUserRoles,
  currencies: () => currencies,
  defaultMimeTypes: () => defaultMimeTypes,
  digitalDossierAccessRequestStatuses: () => digitalDossierAccessRequestStatuses,
  digitalDossierSections: () => digitalDossierSections,
  digitalDossierStatus: () => digitalDossierStatus,
  digitalDossierSubsection: () => digitalDossierSubsection,
  documentTypes: () => documentTypes,
  exchanges: () => exchanges,
  exploitationTypes: () => exploitationTypes,
  fileMimeTypes: () => fileMimeTypes,
  geoDocumentationMimeTypes: () => geoDocumentationMimeTypes,
  identityDocumentTypes: () => identityDocumentTypes,
  ivaCondition: () => ivaCondition,
  leaseContractTypes: () => leaseContractTypes,
  maritalStatuses: () => maritalStatuses,
  nationalityTypes: () => nationalityTypes,
  ownershipTypes: () => ownershipTypes,
  pledgeCropClasses: () => pledgeCropClasses,
  pledgeCropDegreees: () => pledgeCropDegreees,
  pledgeSectionStatuses: () => pledgeSectionStatuses,
  pledgeSections: () => pledgeSections,
  pledgeStatuses: () => pledgeStatuses,
  powerOfAttorneyExchanges: () => powerOfAttorneyExchanges,
  products: () => products,
  profitTypes: () => profitTypes,
  provinces: () => provinces,
  queryStatuses: () => queryStatuses,
  representativePositions: () => representativePositions,
  rucaNotCurrentWarnings: () => rucaNotCurrentWarnings,
  rucaStatuses: () => rucaStatuses,
  searchDigitalDossierActions: () => searchDigitalDossierActions,
  searchDigitalDossierStatuses: () => searchDigitalDossierStatuses,
  signatureLevels: () => signatureLevels,
  sisaActivities: () => sisaActivities,
  sisaScorings: () => sisaScorings,
  userCompanyStatuses: () => userCompanyStatuses,
  userRoles: () => userRoles,
  userStatuses: () => userStatuses,
  userTypes: () => userTypes,
  validationStatuses: () => validationStatuses,
  viewerDigitalDossierGeneralStatus: () => viewerDigitalDossierGeneralStatus,
  yesNoOptions: () => yesNoOptions
});
module.exports = __toCommonJS(src_exports);

// src/enums/admin-roles.enum.ts
var ADMIN_ROLES = {
  MANAGER: "MANAGER",
  VALIDATOR: "VALIDATOR"
};
var adminRoles = Object.values(ADMIN_ROLES);

// src/enums/brute-income-type.enum.ts
var BRUTE_INCOME_TYPES = {
  LOCAL_JURISDICTION: "LOCAL_JURISDICTION",
  MULTILATERAL_AGREEMENT: "MULTILATERAL_AGREEMENT",
  EXEMPT: "EXEMPT"
};
var bruteIncomeTypes = Object.values(BRUTE_INCOME_TYPES);

// src/enums/company-activities.enum.ts
var COMPANY_ACTIVITIES = {
  PRODUCER: "PRODUCER",
  RUNNER: "RUNNER",
  CEREAL_MARKET_AT_THE_END: "CEREAL_MARKET_AT_THE_END",
  OPERATOR_WITH_PLANT: "OPERATOR_WITH_PLANT",
  OPERATOR_WITHOUT_PLANT: "OPERATOR_WITHOUT_PLANT",
  EXCHANGER: "EXCHANGER"
};
var companyActivities = Object.values(COMPANY_ACTIVITIES);

// src/enums/company-status.enum.ts
var COMPANY_STATUSES = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE"
};
var companyStatuses = Object.values(COMPANY_STATUSES);

// src/enums/company-type.enum.ts
var COMPANY_TYPES = {
  PF: "PF",
  // Persona fisica
  SH: "SH",
  // Sociedades de hecho
  SA: "SA",
  // Sociedad anonima
  SRL: "SRL",
  // Sociedad responsabildiad limitada
  SAS: "SAS",
  // Sociedad anonima simplificada
  SAU: "SAU",
  // Sociedad anonima unipersonal
  COOP: "COOP",
  // Cooperativa
  AS: "AS",
  // Asociaciones civiles
  FUND: "FUND",
  // Fundaciones
  FID: "FID",
  // Fideicomisos
  OTHER: "OTHER"
  // Otro
};
var companyTypes = Object.values(COMPANY_TYPES);

// src/enums/currencies.enum.ts
var CURRENCIES = {
  ARS: "ARS",
  USD: "USD"
};
var currencies = Object.values(CURRENCIES);

// src/enums/creditor-inspection-rights.enum.ts
var CREDITOR_INSPECTION_RIGHTS = {
  BROAD: "BROAD",
  LIMITED: "LIMITED"
};
var creditorInspectionRights = Object.values(
  CREDITOR_INSPECTION_RIGHTS
);

// src/enums/crop-pledge-user-roles.enum.ts
var CROP_PLEDGE_USER_ROLES = {
  DEBTOR: "DEBTOR",
  BACKOFFICE: "BACKOFFICE",
  CREDITOR: "CREDITOR"
};
var cropPledgeUserRoles = Object.values(CROP_PLEDGE_USER_ROLES);

// src/enums/document.enum.ts
var DOCUMENT_TYPES = {
  // GENERAL
  IGJ: "IGJ",
  // BANKING
  CBU: "CBU",
  // TAXES
  CUIT: "CUIT",
  IIBB: "IIBB",
  CM05: "CM05",
  PROFITS: "PROFITS",
  IVA: "IVA",
  EXEMPTIONS: "EXEMPTIONS",
  // DOCUMENTATION
  SISA: "SISA",
  PRODUCTION_CAPACITY: "PRODUCTION_CAPACITY",
  STORAGE_CAPACITY: "STORAGE_CAPACITY",
  BALANCE_SHEET: "BALANCE_SHEET",
  OWNER_ID_CARD: "OWNER_ID_CARD",
  STATUTE: "STATUTE",
  STATUTE_CHANGE: "STATUTE_CHANGE",
  ASSEMBLY_BOARD_MINUTES: "ASSEMBLY_BOARD_MINUTES",
  POWERS_OF_ATTORNEY: "POWERS_OF_ATTORNEY",
  ADDITIONAL_FORMS_AND_DOCS_DOCUMENT: "ADDITIONAL_FORMS_AND_DOCS_DOCUMENT",
  // REPRESENTANTS
  REPRESENTATIVE_ID_CARD: "REPRESENTATIVE_ID_CARD",
  SIGNUP_PERMISSION: "SIGNUP_PERMISSION",
  //EQUITY
  ADDITIONAL_EQUITY_DOCUMENT: "ADDITIONAL_EQUITY_DOCUMENT",
  // OTHER
  UNKNOWN: "UNKNOWN",
  // GEOLOCATION
  GEOLOCATION: "GEOLOCATION",
  // CONTRACTS:
  COMPANY_QUERY_LOAD_CONTRACT: "COMPANY_QUERY_LOAD_CONTRACT",
  // CROP PLEDGE
  LOAN_CONTRACT: "LOAN_CONTRACT",
  ADDITIONAL_CROP_PLEDGE_DOCUMENT: "ADDITIONAL_CROP_PLEDGE_DOCUMENT",
  CARBON_ANALYSIS: "CARBON_ANALYSIS",
  DOMAIN_REPORT: "DOMAIN_REPORT",
  MODIFICATION_FORM: "MODIFICATION_FORM",
  REGISTERED_PLEDGE: "REGISTERED_PLEDGE",
  DEREGISTRATION_OF_PLEDGE: "DEREGISTRATION_OF_PLEDGE",
  ADDITIONAL_CROP_PLEDGE_FARM_DOCUMENT: "ADDITIONAL_CROP_PLEDGE_FARM_DOCUMENT",
  PLEDGE_REGISTRATION_FORM_TEMPLATE: "PLEDGE_REGISTRATION_FORM_TEMPLATE"
};
var documentTypes = Object.values(DOCUMENT_TYPES);

// src/enums/digital-dossier-access-request-statuses.enum.ts
var DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  EXPIRED: "EXPIRED",
  REVOKED: "REVOKED"
};
var digitalDossierAccessRequestStatuses = Object.values(
  DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS
);

// src/enums/digital-dossiers/digital-dossier-statuses.enum.ts
var DIGITAL_DOSSIER_STATUS = {
  PENDING_DATA_UPLOAD_CLIENT: "PENDING_DATA_UPLOAD_CLIENT",
  PENDING_DATA_UPLOAD_BACKOFFICE: "PENDING_DATA_UPLOAD_BACKOFFICE",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  APPROVED: "APPROVED"
};
var digitalDossierStatus = Object.values(DIGITAL_DOSSIER_STATUS);

// src/enums/digital-dossiers/client.digital-dossier-statuses.enum.ts
var CLIENT_DIGITAL_DOSSIER_SECTIONS_STATUS = {
  PENDING_DATA_UPLOAD: "PENDING_DATA_UPLOAD",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  PENDING_REVIEW: "PENDING_REVIEW",
  APPROVED: "APPROVED"
};
var clientDigitalDossierSectionsStatus = Object.values(
  CLIENT_DIGITAL_DOSSIER_SECTIONS_STATUS
);
var CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS = {
  INFORMATION_EXPIRED: "INFORMATION_EXPIRED",
  RUCA_EXPIRED: "RUCA_EXPIRED",
  APPROVED: "APPROVED"
};
var clientDigitalDossierGeneralStatus = Object.values(
  CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS
);
var BACKOFFICE_CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS = {
  ...DIGITAL_DOSSIER_STATUS,
  INFORMATION_EXPIRED: "INFORMATION_EXPIRED",
  RUCA_EXPIRED: "RUCA_EXPIRED",
  APPROVED: "APPROVED"
};
var backofficeClientDigitalDossierGeneralStatus = Object.values(
  BACKOFFICE_CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS
);

// src/enums/digital-dossiers/viewer.digital-dossier-statuses.enum.ts
var VIEWER_DIGITAL_DOSSIER_GENERAL_STATUS = {
  INFORMATION_EXPIRED: "INFORMATION_EXPIRED",
  RUCA_EXPIRED: "RUCA_EXPIRED",
  APPROVED: "APPROVED"
};
var viewerDigitalDossierGeneralStatus = Object.values(
  VIEWER_DIGITAL_DOSSIER_GENERAL_STATUS
);

// src/enums/digital-dossier-sections.ts
var DIGITAL_DOSSIER_SECTIONS = {
  DIGITAL_DOSSIER: "DIGITAL_DOSSIER",
  CONTACT_INFORMATION: "CONTACT_INFORMATION",
  DECLARED_JURISDICTIONS: "DECLARED_JURISDICTIONS",
  ASSET_INFORMATION: "ASSET_INFORMATION"
};
var digitalDossierSections = Object.values(DIGITAL_DOSSIER_SECTIONS);

// src/enums/digital-dossier-subsections.ts
var DIGITAL_DOSSIER_SUBSECTIONS = {
  GENERAL_INFO: "GENERAL_INFO",
  TAX_INFO: "TAX_INFO",
  BANKING_INFO: "BANKING_INFO",
  FORMS_AND_DOCS: "FORMS_AND_DOCS",
  LEGAL_REPRESENTANTS: "LEGAL_REPRESENTANTS"
};
var digitalDossierSubsection = Object.values(
  DIGITAL_DOSSIER_SUBSECTIONS
);

// src/enums/exchanges.enum.ts
var EXCHANGES = {
  BCBA: "BCBA"
};
var exchanges = Object.values(EXCHANGES);

// src/enums/exploitation-type.enum.ts
var EXPLOITATION_TYPES = {
  AGRICULTURAL: "AGRICULTURAL",
  LIVE_STOCK: "LIVE_STOCK",
  MIXED: "MIXED"
};
var exploitationTypes = Object.values(EXPLOITATION_TYPES);

// src/enums/file-mime-types.enum.ts
var FILE_MIME_TYPES = {
  JPEG: "image/jpeg",
  PNG: "image/png",
  PDF: "application/pdf",
  KMZ: "application/vnd.google-earth.kmz",
  GEOJSON: "application/geo+json",
  JSON: "application/json"
};
var fileMimeTypes = Object.values(FILE_MIME_TYPES);
var defaultMimeTypes = {
  [FILE_MIME_TYPES.JPEG]: [".jpeg", ".jpg"],
  [FILE_MIME_TYPES.PNG]: [".png"],
  [FILE_MIME_TYPES.PDF]: [".pdf"]
};
var geoDocumentationMimeTypes = {
  [FILE_MIME_TYPES.KMZ]: [".kmz"],
  [FILE_MIME_TYPES.GEOJSON]: [".geojson", ".json"]
};

// src/enums/http-status.enum.ts
var HttpStatus = /* @__PURE__ */ ((HttpStatus2) => {
  HttpStatus2[HttpStatus2["CONTINUE"] = 100] = "CONTINUE";
  HttpStatus2[HttpStatus2["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
  HttpStatus2[HttpStatus2["PROCESSING"] = 102] = "PROCESSING";
  HttpStatus2[HttpStatus2["EARLYHINTS"] = 103] = "EARLYHINTS";
  HttpStatus2[HttpStatus2["OK"] = 200] = "OK";
  HttpStatus2[HttpStatus2["CREATED"] = 201] = "CREATED";
  HttpStatus2[HttpStatus2["ACCEPTED"] = 202] = "ACCEPTED";
  HttpStatus2[HttpStatus2["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
  HttpStatus2[HttpStatus2["NO_CONTENT"] = 204] = "NO_CONTENT";
  HttpStatus2[HttpStatus2["RESET_CONTENT"] = 205] = "RESET_CONTENT";
  HttpStatus2[HttpStatus2["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
  HttpStatus2[HttpStatus2["AMBIGUOUS"] = 300] = "AMBIGUOUS";
  HttpStatus2[HttpStatus2["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
  HttpStatus2[HttpStatus2["FOUND"] = 302] = "FOUND";
  HttpStatus2[HttpStatus2["SEE_OTHER"] = 303] = "SEE_OTHER";
  HttpStatus2[HttpStatus2["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
  HttpStatus2[HttpStatus2["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
  HttpStatus2[HttpStatus2["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
  HttpStatus2[HttpStatus2["BAD_REQUEST"] = 400] = "BAD_REQUEST";
  HttpStatus2[HttpStatus2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  HttpStatus2[HttpStatus2["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
  HttpStatus2[HttpStatus2["FORBIDDEN"] = 403] = "FORBIDDEN";
  HttpStatus2[HttpStatus2["NOT_FOUND"] = 404] = "NOT_FOUND";
  HttpStatus2[HttpStatus2["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
  HttpStatus2[HttpStatus2["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
  HttpStatus2[HttpStatus2["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
  HttpStatus2[HttpStatus2["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
  HttpStatus2[HttpStatus2["CONFLICT"] = 409] = "CONFLICT";
  HttpStatus2[HttpStatus2["GONE"] = 410] = "GONE";
  HttpStatus2[HttpStatus2["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
  HttpStatus2[HttpStatus2["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
  HttpStatus2[HttpStatus2["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
  HttpStatus2[HttpStatus2["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
  HttpStatus2[HttpStatus2["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
  HttpStatus2[HttpStatus2["REQUESTED_RANGE_NOT_SATISFIABLE"] = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE";
  HttpStatus2[HttpStatus2["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
  HttpStatus2[HttpStatus2["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
  HttpStatus2[HttpStatus2["MISDIRECTED"] = 421] = "MISDIRECTED";
  HttpStatus2[HttpStatus2["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
  HttpStatus2[HttpStatus2["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
  HttpStatus2[HttpStatus2["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
  HttpStatus2[HttpStatus2["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
  HttpStatus2[HttpStatus2["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
  HttpStatus2[HttpStatus2["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
  HttpStatus2[HttpStatus2["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
  HttpStatus2[HttpStatus2["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
  HttpStatus2[HttpStatus2["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
  HttpStatus2[HttpStatus2["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
  return HttpStatus2;
})(HttpStatus || {});

// src/enums/identity-document-type.enum.ts
var IDENTITY_DOCUMENT_TYPES = {
  DNI: "DNI",
  ENROLAMIENTO: "ENROLAMIENTO",
  PASSPORT: "PASSPORT"
};
var identityDocumentTypes = Object.values(IDENTITY_DOCUMENT_TYPES);

// src/enums/iva-condition.enum.ts
var IVA_CONDITION = {
  IVA_REGISTERED_RESPONSIBLE: "IVA_REGISTERED_RESPONSIBLE",
  IVA_EXEMPT_SUBJECT: "IVA_EXEMPT_SUBJECT",
  MONOTAX_RESPONSIBLE: "MONOTAX_RESPONSIBLE",
  UNCATEGORIZED_SUBJECT: "UNCATEGORIZED_SUBJECT",
  FOREIGN_SUPPLIER: "FOREIGN_SUPPLIER",
  FOREIGN_CLIENT: "FOREIGN_CLIENT",
  IVA_RELEASED: "IVA_RELEASED",
  MONOTRIBUTIST_SOCIAL: "MONOTRIBUTIST_SOCIAL",
  IVA_NOT_REACHED: "IVA_NOT_REACHED",
  PROMOTED_INDEPENDENT_WORKER_MONOTRIBUTIST: "PROMOTED_INDEPENDENT_WORKER_MONOTRIBUTIST"
};
var ivaCondition = Object.values(IVA_CONDITION);

// src/enums/lease-contract-type.enum.ts
var LEASE_CONTRACT_TYPES = {
  LEASE: "LEASE",
  ACCIDENTAL_LEASE: "ACCIDENTAL_LEASE",
  SHARECROPPING: "SHARECROPPING",
  ACCIDENTAL_SHARECROPPING: "ACCIDENTAL_SHARECROPPING",
  PERCENTAGE_BASED_FARMING: "PERCENTAGE_BASED_FARMING",
  ASSOCIATIVE: "ASSOCIATIVE",
  FREE_TRANSFER_WITH_USUFRUCT_RIGHTS: "FREE_TRANSFER_WITH_USUFRUCT_RIGHTS",
  PAID_TRANSFER_WITH_USUFRUCT_RIGHTS: "PAID_TRANSFER_WITH_USUFRUCT_RIGHTS",
  JOINT_EXPLOITATION_CONTRACT: "JOINT_EXPLOITATION_CONTRACT",
  OTHER: "OTHER"
};
var leaseContractTypes = Object.values(LEASE_CONTRACT_TYPES);

// src/enums/marital-status.enum.ts
var MARITAL_STATUSES = {
  SINGLE: "SINGLE",
  MARRIED: "MARRIED",
  DIVORCED: "DIVORCED",
  WIDOWED: "WIDOWED"
};
var maritalStatuses = Object.values(MARITAL_STATUSES);

// src/enums/nationalities.enum.ts
var NATIONALITIES = {
  ARGENTINE: "ARGENTINE",
  AFGHAN: "AFGHAN",
  ALBANIAN: "ALBANIAN",
  ALGERIAN: "ALGERIAN",
  AMERICAN: "AMERICAN",
  ANDORRAN: "ANDORRAN",
  ANGOLAN: "ANGOLAN",
  ARMENIAN: "ARMENIAN",
  AUSTRALIAN: "AUSTRALIAN",
  AUSTRIAN: "AUSTRIAN",
  AZERBAIJANI: "AZERBAIJANI",
  BAHAMIAN: "BAHAMIAN",
  BAHRAINI: "BAHRAINI",
  BANGLADESHI: "BANGLADESHI",
  BARBADIAN: "BARBADIAN",
  BELARUSIAN: "BELARUSIAN",
  BELGIAN: "BELGIAN",
  BELIZEAN: "BELIZEAN",
  BENINESE: "BENINESE",
  BHUTANESE: "BHUTANESE",
  BOLIVIAN: "BOLIVIAN",
  BOSNIAN: "BOSNIAN",
  BRAZILIAN: "BRAZILIAN",
  BRITISH: "BRITISH",
  BRUNEIAN: "BRUNEIAN",
  BULGARIAN: "BULGARIAN",
  BURKINABE: "BURKINABE",
  BURMESE: "BURMESE",
  BURUNDIAN: "BURUNDIAN",
  CAMBODIAN: "CAMBODIAN",
  CAMEROONIAN: "CAMEROONIAN",
  CANADIAN: "CANADIAN",
  CAPE_VERDEAN: "CAPE_VERDEAN",
  CENTRAL_AFRICAN: "CENTRAL_AFRICAN",
  CHADIAN: "CHADIAN",
  CHILEAN: "CHILEAN",
  CHINESE: "CHINESE",
  COLOMBIAN: "COLOMBIAN",
  COMORIAN: "COMORIAN",
  CONGOLESE: "CONGOLESE",
  COSTA_RICAN: "COSTA_RICAN",
  CROATIAN: "CROATIAN",
  CUBAN: "CUBAN",
  CYPRIOT: "CYPRIOT",
  CZECH: "CZECH",
  DANISH: "DANISH",
  DJIBOUTIAN: "DJIBOUTIAN",
  DOMINICAN: "DOMINICAN",
  DUTCH: "DUTCH",
  EAST_TIMORESE: "EAST_TIMORESE",
  ECUADOREAN: "ECUADOREAN",
  EGYPTIAN: "EGYPTIAN",
  EMIRATI: "EMIRATI",
  EQUATORIAL_GUINEAN: "EQUATORIAL_GUINEAN",
  ERITREAN: "ERITREAN",
  ESTONIAN: "ESTONIAN",
  ETHIOPIAN: "ETHIOPIAN",
  FIJIAN: "FIJIAN",
  FILIPINO: "FILIPINO",
  FINNISH: "FINNISH",
  FRENCH: "FRENCH",
  GABONESE: "GABONESE",
  GAMBIAN: "GAMBIAN",
  GEORGIAN: "GEORGIAN",
  GERMAN: "GERMAN",
  GHANAIAN: "GHANAIAN",
  GREEK: "GREEK",
  GRENADIAN: "GRENADIAN",
  GUATEMALAN: "GUATEMALAN",
  GUINEAN: "GUINEAN",
  GUINEA_BISSAUAN: "GUINEA_BISSAUAN",
  GUYANESE: "GUYANESE",
  HAITIAN: "HAITIAN",
  HONDURAN: "HONDURAN",
  HUNGARIAN: "HUNGARIAN",
  ICELANDER: "ICELANDER",
  INDIAN: "INDIAN",
  INDONESIAN: "INDONESIAN",
  IRANIAN: "IRANIAN",
  IRAQI: "IRAQI",
  IRISH: "IRISH",
  ISRAELI: "ISRAELI",
  ITALIAN: "ITALIAN",
  IVORIAN: "IVORIAN",
  JAMAICAN: "JAMAICAN",
  JAPANESE: "JAPANESE",
  JORDANIAN: "JORDANIAN",
  KAZAKH: "KAZAKH",
  KENYAN: "KENYAN",
  KIRIBATI: "KIRIBATI",
  KOREAN: "KOREAN",
  KUWAITI: "KUWAITI",
  KYRGYZ: "KYRGYZ",
  LAOTIAN: "LAOTIAN",
  LATVIAN: "LATVIAN",
  LEBANESE: "LEBANESE",
  LESOTHO: "LESOTHO",
  LIBERIAN: "LIBERIAN",
  LIBYAN: "LIBYAN",
  LIECHTENSTEINER: "LIECHTENSTEINER",
  LITHUANIAN: "LITHUANIAN",
  LUXEMBOURGISH: "LUXEMBOURGISH",
  MACEDONIAN: "MACEDONIAN",
  MALAGASY: "MALAGASY",
  MALAWIAN: "MALAWIAN",
  MALAYSIAN: "MALAYSIAN",
  MALDIVIAN: "MALDIVIAN",
  MALIEN: "MALIEN",
  MALTESE: "MALTESE",
  MARSHALLESE: "MARSHALLESE",
  MAURITANIAN: "MAURITANIAN",
  MAURITIAN: "MAURITIAN",
  MEXICAN: "MEXICAN",
  MICRONESIAN: "MICRONESIAN",
  MOLDOVAN: "MOLDOVAN",
  MONACAN: "MONACAN",
  MONGOLIAN: "MONGOLIAN",
  MONTENEGRIN: "MONTENEGRIN",
  MOROCCAN: "MOROCCAN",
  MOZAMBICAN: "MOZAMBICAN",
  NAMIBIAN: "NAMIBIAN",
  NAURUAN: "NAURUAN",
  NEPALESE: "NEPALESE",
  NEW_ZEALANDER: "NEW_ZEALANDER",
  NICARAGUAN: "NICARAGUAN",
  NIGERIAN: "NIGERIAN",
  NIGERIEN: "NIGERIEN",
  NORTH_KOREAN: "NORTH_KOREAN",
  NORWEGIAN: "NORWEGIAN",
  OMANI: "OMANI",
  PAKISTANI: "PAKISTANI",
  PALAUAN: "PALAUAN",
  PALESTINIAN: "PALESTINIAN",
  PANAMANIAN: "PANAMANIAN",
  PAPUA_NEW_GUINEAN: "PAPUA_NEW_GUINEAN",
  PARAGUAYAN: "PARAGUAYAN",
  PERUVIAN: "PERUVIAN",
  POLISH: "POLISH",
  PORTUGUESE: "PORTUGUESE",
  QATARI: "QATARI",
  ROMANIAN: "ROMANIAN",
  RUSSIAN: "RUSSIAN",
  RWANDAN: "RWANDAN",
  SAINT_KITTS_AND_NEVIS: "SAINT_KITTS_AND_NEVIS",
  SAINT_LUCIAN: "SAINT_LUCIAN",
  SAINT_VINCENTIAN: "SAINT_VINCENTIAN",
  SAMOAN: "SAMOAN",
  SAN_MARINESE: "SAN_MARINESE",
  SAO_TOMEAN: "SAO_TOMEAN",
  SAUDI: "SAUDI",
  SCOTTISH: "SCOTTISH",
  SENEGALESE: "SENEGALESE",
  SERBIAN: "SERBIAN",
  SEYCHELLOIS: "SEYCHELLOIS",
  SIERRA_LEONEAN: "SIERRA_LEONEAN",
  SINGAPOREAN: "SINGAPOREAN",
  SLOVAK: "SLOVAK",
  SLOVENIAN: "SLOVENIAN",
  SOLOMON_ISLANDER: "SOLOMON_ISLANDER",
  SOMALI: "SOMALI",
  SOUTH_AFRICAN: "SOUTH_AFRICAN",
  SOUTH_KOREAN: "SOUTH_KOREAN",
  SOUTH_SUDANESE: "SOUTH_SUDANESE",
  SPANISH: "SPANISH",
  SRI_LANKAN: "SRI_LANKAN",
  SUDANESE: "SUDANESE",
  SURINAMER: "SURINAMER",
  SWAZI: "SWAZI",
  SWEDISH: "SWEDISH",
  SWISS: "SWISS",
  SYRIAN: "SYRIAN",
  TAIWANESE: "TAIWANESE",
  TAJIK: "TAJIK",
  TANZANIAN: "TANZANIAN",
  THAI: "THAI",
  TOGOLESE: "TOGOLESE",
  TONGAN: "TONGAN",
  TRINIDADIAN: "TRINIDADIAN",
  TUNISIAN: "TUNISIAN",
  TURKISH: "TURKISH",
  TURKMEN: "TURKMEN",
  TUVALUAN: "TUVALUAN",
  UGANDAN: "UGANDAN",
  UKRAINIAN: "UKRAINIAN",
  URUGUAYAN: "URUGUAYAN",
  UZBEK: "UZBEK",
  VANUATUAN: "VANUATUAN",
  VATICAN: "VATICAN",
  VENEZUELAN: "VENEZUELAN",
  VIETNAMESE: "VIETNAMESE",
  WELSH: "WELSH",
  YEMENI: "YEMENI",
  ZAMBIAN: "ZAMBIAN",
  ZIMBABWEAN: "ZIMBABWEAN"
};
var nationalityTypes = Object.values(NATIONALITIES);

// src/enums/ownership-type.enum.ts
var OWNERSHIP_TYPES = {
  OWN: "OWN",
  THIRD_PARTY: "THIRD_PARTY"
};
var ownershipTypes = Object.values(OWNERSHIP_TYPES);

// src/enums/profit-types.enum.ts
var PROFIT_TYPES = {
  REGISTERED: "REGISTERED",
  NOT_REGISTERED: "NOT_REGISTERED",
  EXEMPT: "EXEMPT"
};
var profitTypes = Object.values(PROFIT_TYPES);

// src/enums/power-of-attorney-exchanges.enum.ts
var POWER_OF_ATTORNEY_EXCHANGES = {
  GRAIN_EXCHANGE_BUENOS_AIRES: "GRAIN_EXCHANGE_BUENOS_AIRES",
  GRAIN_EXCHANGE_BAHIA_BLANCA: "GRAIN_EXCHANGE_BAHIA_BLANCA",
  GRAIN_EXCHANGE_ENTRE_RIOS: "GRAIN_EXCHANGE_ENTRE_RIOS",
  GRAIN_EXCHANGE_CORDOBA: "GRAIN_EXCHANGE_CORDOBA",
  GRAIN_EXCHANGE_CHACO: "GRAIN_EXCHANGE_CHACO",
  STOCK_EXCHANGE_ROSARIO: "STOCK_EXCHANGE_ROSARIO",
  STOCK_EXCHANGE_SANTA_FE: "STOCK_EXCHANGE_SANTA_FE"
};
var powerOfAttorneyExchanges = Object.values(
  POWER_OF_ATTORNEY_EXCHANGES
);

// src/enums/products.enum.ts
var PRODUCTS = {
  COTTON: "COTTON",
  RICE: "RICE",
  BARLEY: "BARLEY",
  SUNFLOWER: "SUNFLOWER",
  CORN: "CORN",
  PEANUTS: "PEANUTS",
  SOY: "SOY",
  SORGHUM: "SORGHUM",
  WHEAT: "WHEAT",
  OTHER: "OTHER"
};
var products = Object.values(PRODUCTS);

// src/enums/provinces.enum.ts
var PROVINCES = {
  BUENOS_AIRES: "BUENOS_AIRES",
  CAPITAL_FEDERAL: "CAPITAL_FEDERAL",
  CATAMARCA: "CATAMARCA",
  CHACO: "CHACO",
  CHUBUT: "CHUBUT",
  CORDOBA: "CORDOBA",
  CORRIENTES: "CORRIENTES",
  ENTRE_RIOS: "ENTRE_RIOS",
  FORMOSA: "FORMOSA",
  JUJUY: "JUJUY",
  LA_PAMPA: "LA_PAMPA",
  LA_RIOJA: "LA_RIOJA",
  MENDOZA: "MENDOZA",
  MISIONES: "MISIONES",
  NEUQUEN: "NEUQUEN",
  RIO_NEGRO: "RIO_NEGRO",
  SALTA: "SALTA",
  SAN_JUAN: "SAN_JUAN",
  SAN_LUIS: "SAN_LUIS",
  SANTA_CRUZ: "SANTA_CRUZ",
  SANTA_FE: "SANTA_FE",
  SANTIAGO_DEL_ESTERO: "SANTIAGO_DEL_ESTERO",
  TIERRA_DEL_FUEGO: "TIERRA_DEL_FUEGO",
  TUCUMAN: "TUCUMAN"
};
var provinces = Object.values(PROVINCES);

// src/enums/pledge-crop-classes.enum.ts
var PLEDGE_CROP_CLASSES = {
  FIXED: "FIXED",
  FLOATING: "FLOATING"
};
var pledgeCropClasses = Object.values(PLEDGE_CROP_CLASSES);

// src/enums/pledge-crop-degrees.enum.ts
var PLEDGE_CROP_DEGREES = {
  FIRST_DEGREE: "FIRST_DEGREE"
};
var pledgeCropDegreees = Object.values(PLEDGE_CROP_DEGREES);

// src/enums/pledge-status.enum.ts
var PLEDGE_STATUSES = {
  PENDING_DEBTOR_LOAD: "PENDING_DEBTOR_LOAD",
  PENDING_BOLSA_LOAD: "PENDING_BOLSA_LOAD",
  PENDING_CREDITOR_LOAD: "PENDING_CREDITOR_LOAD",
  PENDING_BOLSA_FARM_LOAD: "PENDING_BOLSA_FARM_LOAD",
  PENDING_DEBTOR_DOCUMENTATION_LOAD: "PENDING_DEBTOR_DOCUMENTATION_LOAD",
  PENDING_BOLSA_APPROVAL: "PENDING_BOLSA_APPROVAL",
  PENDING_CREDITOR_APPROVAL: "PENDING_CREDITOR_APPROVAL",
  PENDING_REGISTRATION: "PENDING_REGISTRATION",
  PENDING_REGISTRATION_BLOCKCHAIN: "PENDING_REGISTRATION_BLOCKCHAIN",
  REGISTERED: "REGISTERED",
  PENDING_RELEASE: "PENDING_RELEASE",
  RELEASED: "RELEASED",
  REJECTED: "REJECTED"
};
var pledgeStatuses = Object.values(PLEDGE_STATUSES);

// src/enums/pledge-section-status.enum.ts
var PLEDGE_SECTION_STATUSES = {
  PENDING_DEBTOR_LOAD: "PENDING_DEBTOR_LOAD",
  PENDING_BOLSA_LOAD: "PENDING_BOLSA_LOAD",
  PENDING_CREDITOR_LOAD: "PENDING_CREDITOR_LOAD",
  PENDING_BOLSA_APPROVAL: "PENDING_BOLSA_APPROVAL",
  PENDING_CREDITOR_APPROVAL: "PENDING_CREDITOR_APPROVAL",
  APPROVED: "APPROVED"
};
var pledgeSectionStatuses = Object.values(PLEDGE_SECTION_STATUSES);

// src/enums/pledge-sections.enum.ts
var PLEDGE_SECTIONS = {
  FARM_INFORMATION: "FARM_INFORMATION",
  DEBTOR_INFORMATION: "DEBTOR_INFORMATION",
  CREDITOR_INFORMATION: "CREDITOR_INFORMATION",
  DOCUMENTATION: "DOCUMENTATION",
  PLEDGE_INFORMATION: "PLEDGE_INFORMATION",
  INSURANCE: "INSURANCE"
};
var pledgeSections = Object.values(PLEDGE_SECTIONS);

// src/enums/query-statuses.enum.ts
var QUERY_STATUSES = {
  IN_PROGRESS: "IN_PROGRESS",
  REJECTED: "REJECTED",
  APPROVED: "APPROVED"
};
var queryStatuses = Object.values(QUERY_STATUSES);

// src/enums/representative-positions.enum.ts
var REPRESENTATIVE_POSITIONS = {
  PRESIDENT: "PRESIDENT",
  PROXY: "PROXY",
  INCUMBENT: "INCUMBENT",
  MANAGING_PARTNER: "MANAGING_PARTNER",
  OTHER: "OTHER"
};
var representativePositions = Object.values(REPRESENTATIVE_POSITIONS);

// src/enums/ruca-statuses.enum.ts
var RUCA_STATUSES = {
  CURRENT: "CURRENT",
  NOT_CURRENT: "NOT_CURRENT"
};
var rucaStatuses = Object.values(RUCA_STATUSES);

// src/enums/ruca-not-current-warning.enum.ts
var RUCA_NOT_CURRENT_WARNING = {
  CLIENT_DOSSIER_REMAINS_ACTIVE: "CLIENT_DOSSIER_REMAINS_ACTIVE",
  CLIENT_DOSSIER_REMAINS_EXPIRED: "CLIENT_DOSSIER_REMAINS_EXPIRED",
  VIEWER_DOSSIER_REMAINS_ACTIVE: "VIEWER_DOSSIER_REMAINS_ACTIVE",
  VIEWER_DOSSIER_REMAINS_EXPIRED: "VIEWER_DOSSIER_REMAINS_EXPIRED"
};
var rucaNotCurrentWarnings = Object.values(RUCA_NOT_CURRENT_WARNING);

// src/enums/signature-levels.enum.ts
var SIGNATURE_LEVELS = {
  ZERO: "ZERO",
  ONE: "ONE",
  TWO: "TWO",
  THREE: "THREE",
  NINE: "NINE"
};
var signatureLevels = Object.values(SIGNATURE_LEVELS);

// src/enums/sisa-activities.enum.ts
var SISA_ACTIVITIES = {
  PRODUCER: "PRODUCER",
  BROKER: "BROKER",
  FUTURES_GRAIN_MARKET: "FUTURES_GRAIN_MARKET",
  OPERATOR_WITH_A_PLANT: "OPERATOR_WITH_A_PLANT",
  OPERATOR_WITHOUT_A_PLANT: "OPERATOR_WITHOUT_A_PLANT",
  BARTERER: "BARTERER"
};
var sisaActivities = Object.values(SISA_ACTIVITIES);

// src/enums/sisa-scorings.enum.ts
var SISA_SCORINGS = {
  SITUATION_1: "SITUATION_1",
  SITUATION_2: "SITUATION_2",
  SITUATION_3: "SITUATION_3"
};
var sisaScorings = Object.values(SISA_SCORINGS);

// src/enums/search-digital-dossier-status.enum.ts
var SEARCH_DIGITAL_DOSSIER_STATUS = {
  PENDING: "PENDING",
  AVAILABLE: "AVAILABLE"
};
var searchDigitalDossierStatuses = Object.values(
  SEARCH_DIGITAL_DOSSIER_STATUS
);

// src/enums/search-digital-dossier-actions.enum.ts
var SEARCH_DIGITAL_DOSSIER_ACTIONS = {
  VIEW: "VIEW",
  REQUEST_ACCESS: "REQUEST_ACCESS"
};
var searchDigitalDossierActions = Object.values(
  SEARCH_DIGITAL_DOSSIER_ACTIONS
);

// src/enums/user-company-status-enum.ts
var USER_COMPANY_STATUSES = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE"
};
var userCompanyStatuses = Object.values(USER_COMPANY_STATUSES);

// src/enums/user-roles.enum.ts
var USER_ROLES = {
  CLIENT: "CLIENT"
};
var userRoles = Object.values(USER_ROLES);

// src/enums/user-status.enum.ts
var USER_STATUSES = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE"
};
var userStatuses = Object.values(USER_STATUSES);

// src/enums/user-types.enum.ts
var USER_TYPES = {
  EXPLORER: "EXPLORER",
  BACKOFFICE: "BACKOFFICE"
};
var userTypes = Object.values(USER_TYPES);

// src/enums/validation-statuses.enum.ts
var VALIDATION_STATUSES = {
  INCOMPLETE: "INCOMPLETE",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  PENDING_CHANGE_REQUEST: "PENDING_CHANGE_REQUEST",
  REJECTED: "REJECTED",
  APPROVED: "APPROVED"
};
var validationStatuses = Object.values(VALIDATION_STATUSES);

// src/enums/yes-no-options.enum.ts
var YES_NO_OPTIONS = {
  YES: "YES",
  NO: "NO"
};
var yesNoOptions = Object.values(YES_NO_OPTIONS);

// src/common/error-codes.ts
var ERROR_CODES = {
  // 400
  VALIDATION_ERROR: "VALIDATION_ERROR",
  CANNOT_SHARE_CERTIFICATES_FROM_ANOTHER_COMPANY: "CANNOT_SHARE_CERTIFICATES_FROM_ANOTHER_COMPANY",
  CANNOT_SHARE_CERTIFICATES_WITH_YOURSELF: "CANNOT_SHARE_CERTIFICATES_WITH_YOURSELF",
  CANNOT_APPROVE_FACILITY_WITHOUT_AFFIDAVIT: "CANNOT_APPROVE_FACILITY_WITHOUT_AFFIDAVIT",
  // 401
  MISSING_CREDENTIALS: "MISSING_CREDENTIALS",
  INVALID_TOKEN: "INVALID_TOKEN",
  // 403
  FORBIDDEN_RESOURCE: "FORBIDDEN_RESOURCE",
  // 404
  RECORD_NOT_FOUND: "RECORD_NOT_FOUND",
  // 409
  EMAIL_ALREADY_EXISTS: "EMAIL_ALREADY_EXISTS",
  FISCAL_ID_IN_USE: "FISCAL_ID_IN_USE",
  DUPLICATED_ENTITY: "DUPLICATED_ENTITY",
  EMPTY_FILE: "EMPTY_FILE",
  USER_ALREADY_EXISTS: "USER_ALREADY_EXISTS",
  CUIT_MUST_BE_11_DIGITS: "CUIT_MUST_BE_11_DIGITS",
  CUIT_INVALID: "CUIT_INVALID",
  CUIT_NOT_FOUND_IN_AFIP: "CUIT_NOT_FOUND_IN_AFIP",
  COMPANY_ALREADY_EXISTS: "COMPANY_ALREADY_EXISTS",
  SNAPSHOT_ALREADY_REJECTED: "SNAPSHOT_ALREADY_REJECTED",
  SNAPSHOT_MUST_BE_PENDING_APPROVAL: "SNAPSHOT_MUST_BE_PENDING_APPROVAL",
  SNAPSHOT_PREVIOUSLY_REJECTED_OR_APPROVED: "SNAPSHOT_PREVIOUSLY_REJECTED_OR_APPROVED",
  SNAPSHOT_NON_ACTIVE: "SNAPSHOT_NON_ACTIVE",
  SNAPSHOT_WITH_MISSING_INFORMATION: "SNAPSHOT_WITH_MISSING_INFORMATION",
  COMPANY_MISSING_A_CERTIFIED_DIGITAL_DOSSIER: "COMPANY_MISSING_A_CERTIFIED_DIGITAL_DOSSIER",
  COMPANY_DOES_NOT_HAVE_AVAILABLE_QUERIES: "COMPANY_DOES_NOT_HAVE_AVAILABLE_QUERIES",
  SIGNUP_REQUEST_ALREADY_REJECTED: "SIGNUP_REQUEST_ALREADY_REJECTED",
  SIGNUP_REQUEST_ALREADY_APPROVED: "SIGNUP_REQUEST_ALREADY_APPROVED",
  SIGNUP_REQUEST_NOT_IN_A_PENDING_APPROVAL_STATUS: "SIGNUP_REQUEST_NOT_IN_A_PENDING_APPROVAL_STATUS",
  SIGNUP_REQUEST_NOT_IN_A_PENDING_CHANGE_REQUEST_STATUS: "SIGNUP_REQUEST_NOT_IN_A_PENDING_CHANGE_REQUEST_STATUS",
  SNAPSHOT_ALREADY_APPROVED: "SNAPSHOT_ALREADY_APPROVED",
  // 422
  MALFORMED_REQUEST: "MALFORMED_REQUEST",
  PROCESSING_ERROR: "PROCESSING_ERROR",
  NOT_YET_SUPPORTED: "NOT_YET_SUPPORTED",
  CERTIFICATE_REQUEST_ALREADY_IN_PROGRESS: "CERTIFICATE_REQUEST_ALREADY_IN_PROGRESS",
  BRUTE_INCOME_LOCAL_JURISDICTION_MUST_HAVE_SINGLE_JURISDICTION: "BRUTE_INCOME_LOCAL_JURISDICTION_MUST_HAVE_SINGLE_JURISDICTION",
  BRUTE_INCOME_MULTILATERAL_AGREEMENT_MUST_HAVE_AT_LEAST_ONE_JURISDICTION: "BRUTE_INCOME_MULTILATERAL_AGREEMENT_MUST_HAVE_AT_LEAST_ONE_JURISDICTION",
  BRUTE_INCOME_EXEMPT_MUST_NOT_HAVE_JURISDICTIONS: "BRUTE_INCOME_EXEMPT_MUST_NOT_HAVE_JURISDICTIONS",
  UPDATES_NOT_TRIGGERED_CHANGES: "UPDATES_NOT_TRIGGERED_CHANGES",
  CROP_PLEDGE_NO_DIGITAL_DOSSIER: "CROP_PLEDGE_NO_DIGITAL_DOSSIER",
  CROP_PLEDGE_NO_COMPANY_CONTACT_INFORMATION: "CROP_PLEDGE_NO_COMPANY_CONTACT_INFORMATION",
  CROP_PLEDGE_COMPANY_IS_NOT_PRODUCER: "CROP_PLEDGE_COMPANY_IS_NOT_PRODUCER",
  CROP_PLEDGE_NO_PHONE_NUMBER: "CROP_PLEDGE_NO_PHONE_NUMBER",
  CROP_PLEDGE_NO_EMAIL: "CROP_PLEDGE_NO_EMAIL",
  CROP_PLEDGE_NO_CP: "CROP_PLEDGE_NO_CP",
  CROP_PLEDGE_NO_INCUMBENT: "CROP_PLEDGE_NO_INCUMBENT",
  CROP_PLEDGE_CANT_USE_OWN_COMPANY: "CROP_PLEDGE_CANT_USE_OWN_COMPANY",
  CROP_PLEDGE_COMPANY_NOT_FOUND: "CROP_PLEDGE_COMPANY_NOT_FOUND",
  CROP_PLEDGE_CREDITOR_INFORMATION_NOT_FOUND: "CROP_PLEDGE_CREDITOR_INFORMATION_NOT_FOUND",
  CROP_PLEDGE_FARM_INFORMATION_NOT_FOUND: "CROP_PLEDGE_FARM_INFORMATION_NOT_FOUND",
  CROP_PLEDGE_USER_IS_NOT_CREDITOR: "CROP_PLEDGE_USER_IS_NOT_CREDITOR",
  CROP_PLEDGE_NOT_IN_CREDITOR_APPROVAL_STATUS: "CROP_PLEDGE_NOT_IN_CREDITOR_APPROVAL_STATUS",
  CROP_PLEDGE_SECTIONS_NOT_IN_APPROVED_STATUS: "CROP_PLEDGE_SECTIONS_NOT_IN_APPROVED_STATUS",
  CROP_PLEDGE_INVALID_STAGE: "CROP_PLEDGE_INVALID_STAGE",
  CROP_PLEDGE_INVALID_CREDITOR_SELECTION: "CROP_PLEDGE_INVALID_CREDITOR_SELECTION",
  // 500
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  ERROR_SENDING_EMAIL: "ERROR_SENDING_EMAIL",
  ERROR_UPLOADING_FILE: "ERROR_UPLOADING_FILE",
  ERROR_DELETING_FILE: "ERROR_DELETING_FILE",
  ERROR_FETCHING_FILE: "ERROR_FETCHING_FILE",
  ERR_NETWORK: "ERR_NETWORK"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ADMIN_ROLES,
  BACKOFFICE_CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS,
  BRUTE_INCOME_TYPES,
  CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS,
  CLIENT_DIGITAL_DOSSIER_SECTIONS_STATUS,
  COMPANY_ACTIVITIES,
  COMPANY_STATUSES,
  COMPANY_TYPES,
  CREDITOR_INSPECTION_RIGHTS,
  CROP_PLEDGE_USER_ROLES,
  CURRENCIES,
  DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS,
  DIGITAL_DOSSIER_SECTIONS,
  DIGITAL_DOSSIER_STATUS,
  DIGITAL_DOSSIER_SUBSECTIONS,
  DOCUMENT_TYPES,
  ERROR_CODES,
  EXCHANGES,
  EXPLOITATION_TYPES,
  FILE_MIME_TYPES,
  HttpStatus,
  IDENTITY_DOCUMENT_TYPES,
  IVA_CONDITION,
  LEASE_CONTRACT_TYPES,
  MARITAL_STATUSES,
  NATIONALITIES,
  OWNERSHIP_TYPES,
  PLEDGE_CROP_CLASSES,
  PLEDGE_CROP_DEGREES,
  PLEDGE_SECTIONS,
  PLEDGE_SECTION_STATUSES,
  PLEDGE_STATUSES,
  POWER_OF_ATTORNEY_EXCHANGES,
  PRODUCTS,
  PROFIT_TYPES,
  PROVINCES,
  QUERY_STATUSES,
  REPRESENTATIVE_POSITIONS,
  RUCA_NOT_CURRENT_WARNING,
  RUCA_STATUSES,
  SEARCH_DIGITAL_DOSSIER_ACTIONS,
  SEARCH_DIGITAL_DOSSIER_STATUS,
  SIGNATURE_LEVELS,
  SISA_ACTIVITIES,
  SISA_SCORINGS,
  USER_COMPANY_STATUSES,
  USER_ROLES,
  USER_STATUSES,
  USER_TYPES,
  VALIDATION_STATUSES,
  VIEWER_DIGITAL_DOSSIER_GENERAL_STATUS,
  YES_NO_OPTIONS,
  adminRoles,
  backofficeClientDigitalDossierGeneralStatus,
  bruteIncomeTypes,
  clientDigitalDossierGeneralStatus,
  clientDigitalDossierSectionsStatus,
  companyActivities,
  companyStatuses,
  companyTypes,
  creditorInspectionRights,
  cropPledgeUserRoles,
  currencies,
  defaultMimeTypes,
  digitalDossierAccessRequestStatuses,
  digitalDossierSections,
  digitalDossierStatus,
  digitalDossierSubsection,
  documentTypes,
  exchanges,
  exploitationTypes,
  fileMimeTypes,
  geoDocumentationMimeTypes,
  identityDocumentTypes,
  ivaCondition,
  leaseContractTypes,
  maritalStatuses,
  nationalityTypes,
  ownershipTypes,
  pledgeCropClasses,
  pledgeCropDegreees,
  pledgeSectionStatuses,
  pledgeSections,
  pledgeStatuses,
  powerOfAttorneyExchanges,
  products,
  profitTypes,
  provinces,
  queryStatuses,
  representativePositions,
  rucaNotCurrentWarnings,
  rucaStatuses,
  searchDigitalDossierActions,
  searchDigitalDossierStatuses,
  signatureLevels,
  sisaActivities,
  sisaScorings,
  userCompanyStatuses,
  userRoles,
  userStatuses,
  userTypes,
  validationStatuses,
  viewerDigitalDossierGeneralStatus,
  yesNoOptions
});
